export default __webpack_public_path__ + "static/media/Member_IChihSha.e5ee570e.jpg";